module.exports = __webpack_public_path__ + "static/media/TSHARE-FTM.07de9070.png";